import { Button, Chip, Icons, SectionCard } from '@kg-internal/pv3-uikit';
import styles from './FilterResult.module.scss';

type Props = {
  filters: {
    label: string;
    value:
      | boolean
      | string[]
      | {
          startDate: Date;
          endDate: Date;
        }
      | undefined;
    name: string;
  }[];
  onDelete: (name: string) => void;
  onEdit: (name: string) => void;
};

const block = 'filter-result';

const FilterCard = ({ children, name }: { children: React.ReactNode; name: string }) => (
  <SectionCard className={styles[`${block}__card`]} key={name}>
    {children}
  </SectionCard>
);
const FilterResult = ({ filters, onDelete, onEdit }: Props) => {
  const getButtons = (name: string) => (
    <div className={styles[`${block}__buttons-container`]}>
      <Button onClick={() => onDelete(name)} className={styles[`${block}__buttons-button`]}>
        {Icons.Delete}
      </Button>
      <Button onClick={() => onEdit(name)} className={styles[`${block}__buttons-button`]}>
        {Icons.Edit}
      </Button>
    </div>
  );

  const getFilterElement = (filter: {
    label: string;
    value:
      | boolean
      | string[]
      | {
          startDate: Date;
          endDate: Date;
        }
      | undefined;
    name: string;
  }) => {
    if (typeof filter.value === 'boolean') {
      return (
        <FilterCard key={filter.name} name={filter.name}>
          <div className={styles[`${block}__boolean-heading-container`]}>
            {filter.value ? (
              <div className={styles[`${block}__icon--image`]}>{Icons.CheckmarkCircleGreen}</div>
            ) : (
              <i className='fa-solid fa-circle-xmark fa-lg' style={{ color: '#ff0000' }} />
            )}
            <h3 className={styles[`${block}__boolean-heading-heading`]}>{filter.label}</h3>
            {getButtons(filter.name)}
          </div>
        </FilterCard>
      );
    }
    if (Array.isArray(filter.value)) {
      return (
        <FilterCard key={filter.name} name={filter.name}>
          <div className={styles[`${block}__heading-container`]}>
            <h3 className={styles[`${block}__heading`]}>{filter.label}</h3>
            {getButtons(filter.name)}
          </div>
          <div className={styles[`${block}__chip-container`]}>
            {filter.value.map((value) => (
              <div className={styles[`${block}__chip`]} key={value}>
                <Chip label={value} big highlight='blue' />
              </div>
            ))}
          </div>
        </FilterCard>
      );
    }

    if (!Array.isArray(filter.value) && typeof filter.value === 'object') {
      return (
        <FilterCard key={filter.name} name={filter.name}>
          <div className={styles[`${block}__heading-container`]}>
            <h3 className={styles[`${block}__heading`]}>{filter.label}</h3>
            {getButtons(filter.name)}
          </div>

          <div className={styles[`${block}__date-group`]}>
            <div className={styles[`${block}__date-container`]}>
              <h4>Start Date</h4>
              <Chip label={filter.value.startDate.toISOString().split('T')[0]} big highlight='blue' />
            </div>

            <div className={styles[`${block}__date-container`]}>
              <h4>End Date</h4>
              <Chip label={filter.value.endDate.toISOString().split('T')[0]} big highlight='blue' />
            </div>
          </div>
        </FilterCard>
      );
    }
    return null;
  };

  return <div className={styles[`${block}__container`]}>{filters.map((filter) => getFilterElement(filter))}</div>;
};

export default FilterResult;
